export default __webpack_public_path__ + "static/GIAC-0311980ab5681a8c21b90f771a639387.jpg";